import { useCallback } from 'react';
import useDatabase from '@pkg/database/useDatabase';
import useMutation from '@pkg/graphql/useMutation';
import useStore from '../useStore';

const UPDATE_ACTIVITY = /* GraphQL */ `
  mutation UpdateLibraryActivity($input: UpdateLibraryActivityInput!) {
    updateLibraryActivity(input: $input) {
      uuid
      description
      process_id
      order
    }
  }
`;

/**
 * @return {Function}
 */
export default function useUpdate() {
  const database = useDatabase();
  const storeUpdate = useStore((state) => state.update);
  const { mutateAsync } = useMutation({
    mutation: UPDATE_ACTIVITY,
  });

  /**
   * @param {String} uuid
   * @param {Object} attributes - Attributes to update (e.g. { description, process_id })
   * @returns {Promise}
   */
  function updateActivity(uuid, attributes) {
    const input = { uuid, ...attributes };
    storeUpdate(uuid, attributes); // Optimistic update to Zustand store
    database.activities.update(uuid, attributes); // @todo rollback
    return mutateAsync(input);
  }

  return useCallback(updateActivity, [mutateAsync, storeUpdate]);
}
